import CartaService from '../../services/CartaService';

export async function getCartaIdAppName(id: string, cartaidService: CartaService)  {

    let existing = JSON.parse(sessionStorage.getItem('cartaId.apps')) || [];
    const found = existing?.find(([storedId]) => storedId === id);
    
    if (found != null)
        return found[1];
    
    const appId = id.split('-');
    const cartaIdInfo = await cartaidService.getCartaIdInfo(appId[0], appId[1]);

    existing.unshift([id, cartaIdInfo.name]);
    
    //Keep latest
    const limited = existing.slice(0,20);

    sessionStorage.setItem('cartaId.apps', JSON.stringify(limited));
    return cartaIdInfo.name;
}